// src/components/Status/StatusList.jsx
import React from 'react';
import StatusCard from './StatusCard';
import StatusListHeader from './StatusListHeader'; // 헤더 컴포넌트 import
import './StatusList.css';

function StatusList({ machinery }) {
  // Sort the machinery array by machineName
  const sortedMachinery = [...machinery].sort((a, b) =>
    a.machineName.localeCompare(b.machineName, undefined, { numeric: true })
  );

  return (
    <div className="status-list-container"> {/* 상위 컨테이너 추가 */}
      {/*<StatusListHeader /> {/* 헤더 렌더링 }*/}
      <div className="status-list">
        {sortedMachinery.map((machine) => (
          <StatusCard key={machine.machineID} machine={machine} />
        ))}
      </div>
    </div>
  );
}

export default StatusList;
